/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* VDK Web ProgramGuide Component (@accedo/vdkweb-epg) 7.2.8
* 
*******************************************************************************/
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _loadingTile = _interopRequireDefault(require("./loadingTile.scss"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/**
 * A tile to show while data is loading in the
 * Program Guide grid.
 *
 * Only shows a given text in the middle of the tile,
 * this is set to 'Loading...' by default.
 *
 * @param {object} props See propTypes
 * @returns {LoadingTile} A LoadingTile component
 */
var LoadingTile = function LoadingTile(_ref) {
  var _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? _loadingTile["default"] : _ref$theme;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: theme.loadingTile,
    style: style
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: theme.loaderContainer
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: theme.loader
  })));
};
LoadingTile.propTypes = {
  /** Style object to be applied to the outer container div */
  style: _propTypes["default"].object,
  /** Classname API for theming */
  theme: _propTypes["default"].shape({
    loader: _propTypes["default"].string,
    loaderContainer: _propTypes["default"].string
  })
};
var _default = /*#__PURE__*/_react["default"].memo(LoadingTile);
exports["default"] = _default;